import { adminHttpClient } from '../../../commons/adminHttpClient'

export interface EmployeeReimbursementsDue {
  companyUserId: string
  firstName: string
  lastName: string
  Ein: string
  nonTaxed: number
  taxable: number
  amount: number
  accruedAllowance: number
  totalExpenses: number
  reimbursements: number
  reimbursementsDue: number
  hasTaxAdvantageAmount: boolean
  expenses: ExpenseInfo[]
}

interface ExpenseInfo {
  id: string
  number: number
  //requestedAmount: number;
  approvedAmmount: number
  amountToReimburse: number
  taxable: number
  nonTaxed: number
  purchaseDate: string
}

export interface EmployeeReimbursementsRequest {
  planPeriodId: string
  dateThrough?: string
}

const getReimbursementsDue = (request: EmployeeReimbursementsRequest): Promise<any> => {
  return adminHttpClient.get(`/AdminDashboard/ReimbursementsDue/EmployeeReimbursements`, request)
}

export default getReimbursementsDue
